/* OUTLETLET_MIRROR_REVIEW_SOURCES_START
 * 流媒体后视镜评论本土化配置。
 * Shopify -> 在线商店 -> 主题 -> 编辑代码 -> assets/outletlet-review-sources.js
 * 评论来源由 PageFly 页面 Custom code > JavaScript 中的 OutletletMirrorReviewConfig 配置。
 * productId 留空时保持现有评论；不要填写变体 ID、商品链接或其他店铺的 ID。
 * h 和 defaultTab 可从该商品原生页面的 Loox iframe 参数取得。
 */
(function () {
  'use strict';

  var JAPANESE_REVIEW_SOURCE = { productId: '', h: '', defaultTab: '' };
  var DEFAULT_REVIEW_CONFIG = { productId: '10804776861980' };
  var LOOX_REVIEW_MAP = {
    'ja-jp': JAPANESE_REVIEW_SOURCE,
    'ja': JAPANESE_REVIEW_SOURCE
    // 新增语言时配置独立来源；例如 'fr-fr': { productId: '', h: '', defaultTab: '' }
  };

  var namespace = 'OutletletMirrorReviewSources';
  var prior = window[namespace];
  if (prior && typeof prior.destroy === 'function') prior.destroy();
  var frameStates = new WeakMap();
  var widgetObserver;
  var mountObserver;
  var observedWidget;
  var queued = false;
  var stopped = false;

  function validConfig(config) {
    return config && /^[1-9]\d*$/.test(String(config.productId || '').trim());
  }

  function getSelection() {
    var match = window.location.pathname.toLowerCase().match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?=\/|$)/);
    var locale = match ? match[1] : String(document.documentElement.lang || 'en').toLowerCase();
    var language = locale.split('-')[0];
    var pageConfig = window.OutletletMirrorReviewConfig;
    var sources = pageConfig && pageConfig.sources ? pageConfig.sources : LOOX_REVIEW_MAP;
    var config = validConfig(sources[locale]) ? sources[locale] :
      validConfig(sources[language]) ? sources[language] : null;
    return { language: language, config: config };
  }

  function restoreParameter(url, original, name) {
    if (original.searchParams.has(name)) url.searchParams.set(name, original.searchParams.get(name));
    else url.searchParams.delete(name);
  }

  function apply() {
    if (stopped) return;
    var widget = document.getElementById('looxReviews');
    if (!widget) return;
    if (observedWidget !== widget) {
      if (widgetObserver) widgetObserver.disconnect();
      observedWidget = widget;
      widgetObserver = new MutationObserver(schedule);
      widgetObserver.observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'data-product-id', 'data-mode'] });
    }

    var frame = widget.querySelector('#looxReviewsFrame') || widget.querySelector('iframe[src*="/reviews/"]');
    if (!frame || !frame.getAttribute('src')) return;
    var current;
    try { current = new URL(frame.getAttribute('src'), document.baseURI); }
    catch (_) { return; }
    // 只处理 OUTLETLET 本店的 Loox 组件。
    if (current.origin !== 'https://loox.io' || !/^\/widget\/XL-2xIr8FP\/reviews\/\d+\/?$/.test(current.pathname)) return;

    var selected = getSelection();
    var state = frameStates.get(frame);
    // 尚未导入/配置本地评论时，不改动来源、语言、每批条数或其他参数。
    if (!selected.config && (!state || !state.switched)) return;
    if (!state) {
      state = { original: new URL(current.href), originalMode: widget.getAttribute('data-mode'), switched: false };
      frameStates.set(frame, state);
    }
    var target = String((selected.config || DEFAULT_REVIEW_CONFIG).productId).trim();
    var next = new URL(current.href);
    next.pathname = next.pathname.replace(/\/reviews\/\d+(?=\/|$)/, '/reviews/' + target);
    restoreParameter(next, state.original, 'h');
    restoreParameter(next, state.original, 'default_tab');
    if (selected.config && selected.config.h) next.searchParams.set('h', String(selected.config.h).trim());
    if (selected.config && selected.config.defaultTab) next.searchParams.set('default_tab', String(selected.config.defaultTab).trim());
    // Japanese reviews include photo and text-only entries; other locales keep the PageFly setting.
    if (selected.config) next.searchParams.set('mode', 'all');
    else restoreParameter(next, state.original, 'mode');
    next.searchParams.set('language', selected.language);
    if (widget.getAttribute('data-product-id') !== target) widget.setAttribute('data-product-id', target);
    if (selected.config) {
      if (widget.getAttribute('data-mode') !== 'all') widget.setAttribute('data-mode', 'all');
    } else if (state.originalMode === null) {
      if (widget.hasAttribute('data-mode')) widget.removeAttribute('data-mode');
    } else if (widget.getAttribute('data-mode') !== state.originalMode) {
      widget.setAttribute('data-mode', state.originalMode);
    }
    state.switched = Boolean(selected.config);
    // 地址正确时不重新加载；保留每批条数及各语言原有展示参数。
    if (next.href !== current.href) frame.setAttribute('src', next.href);
  }

  function schedule() {
    if (queued || stopped) return;
    queued = true;
    Promise.resolve().then(function () { queued = false; apply(); });
  }

  function start() {
    if (stopped) return;
    apply();
    if (!mountObserver && document.body) {
      mountObserver = new MutationObserver(function (records) {
        if (!document.getElementById('looxReviews')) return;
        // 支持组件首次异步插入或整体重新挂载。
        if (document.getElementById('looxReviews') !== observedWidget) schedule();
      });
      mountObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  function destroy() {
    stopped = true;
    if (widgetObserver) widgetObserver.disconnect();
    if (mountObserver) mountObserver.disconnect();
    document.removeEventListener('DOMContentLoaded', start);
    window.removeEventListener('load', start);
    window.removeEventListener('popstate', schedule);
    window.removeEventListener('pageshow', schedule);
  }

  window[namespace] = { version: '1.2.0', refresh: schedule, destroy: destroy };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.addEventListener('load', start);
  window.addEventListener('popstate', schedule);
  window.addEventListener('pageshow', schedule);
})();
/* OUTLETLET_MIRROR_REVIEW_SOURCES_END */

